/* eslint-env browser */

/**
 * Scroll Progress Indicator
 * Shows reading progress based on article content, not full page scroll.
 *
 * Only activates on pages with 'post-template' body class.
 * Progress reaches 100% when article bottom enters viewport.
 */

(function (window, document) {
    // Only run on post pages
    if (!document.body.classList.contains('post-template')) return;

    // Find the article element
    var article = document.querySelector('article.article');
    if (!article) return;

    // Create indicator element
    var indicator = document.createElement('div');
    indicator.id = 'scroll-indicator';
    document.body.appendChild(indicator);

    // Cache article boundaries (recalculated on resize)
    var articleTop = 0;
    var articleHeight = 0;

    function calculateBoundaries() {
        var rect = article.getBoundingClientRect();
        var scrollTop = window.scrollY;
        articleTop = rect.top + scrollTop;
        articleHeight = article.offsetHeight;
    }

    function updateProgress() {
        var scrollTop = window.scrollY;
        var viewportHeight = window.innerHeight;
        var progress;

        // Point where article bottom enters viewport
        var articleBottom = articleTop + articleHeight;
        var targetScroll = articleBottom - viewportHeight;

        // Handle short articles (smaller than viewport)
        if (articleHeight <= viewportHeight) {
            // Show 100% once article is visible
            progress = scrollTop >= articleTop ? 100 : 0;
            indicator.style.width = progress + '%';
            return;
        }

        // Calculate progress from article start to article bottom entering viewport
        var scrollRange = targetScroll - articleTop;

        if (scrollTop <= articleTop) {
            // Haven't reached article yet
            indicator.style.width = '0%';
        } else if (scrollTop >= targetScroll) {
            // Article bottom is in viewport or past it
            indicator.style.width = '100%';
        } else {
            // Reading the article
            progress = ((scrollTop - articleTop) / scrollRange) * 100;
            indicator.style.width = progress + '%';
        }
    }

    // Debounced resize handler
    var resizeTimeout;
    function handleResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            calculateBoundaries();
            updateProgress();
        }, 100);
    }

    // Initialize
    calculateBoundaries();
    updateProgress();

    // Event listeners
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', handleResize);
})(window, document);
